import { useAppSelector } from "./hooks";
import useCurrencyPrices from "./useCurrencyPrices";

export const usePriceToSelectedCurrency = () => {
    const { house } = useAppSelector((state) => state.landing_house);
    const { SELECTED_CURRENCY, SOLES_PRICE, EUR_PRICE } = useCurrencyPrices();

    const price_to_currency = (price: number, tipo_moneda?: string) => {
        let precio_final = 0;
        const moneda = tipo_moneda || SELECTED_CURRENCY;
        if (house.tipo_moneda === "USD") {
            if (moneda === house.tipo_moneda) {
                precio_final = price;
            } else if (moneda === "PEN") {
                precio_final = price * SOLES_PRICE;
            } else if (moneda === "EUR") {
                precio_final = price * EUR_PRICE;
            }
        } else if (house.tipo_moneda === "PEN") {
            if (moneda === house.tipo_moneda) {
                precio_final = price;
            } else if (moneda === "USD") {
                precio_final = price / SOLES_PRICE;
            } else if (moneda === "EUR") {
                precio_final = (price / SOLES_PRICE) * EUR_PRICE;
            }
        } else if (house.tipo_moneda === "EUR") {
            if (moneda === house.tipo_moneda) {
                precio_final = price;
            } else if (moneda === "USD") {
                precio_final = price / EUR_PRICE;
            } else if (moneda === "PEN") {
                precio_final = (price / EUR_PRICE) * SOLES_PRICE;
            }
        }

        return Math.ceil(precio_final);
    };

    return {
        price_to_currency,
    };
};
